import { types } from './actions';

const initialState = {
  showWellEntryModal: false,
  showWellMergeModal: false,
  well: null,
};


const wellList = (state = initialState, action) => {
  switch (action.type) {
    case types.OPEN_WELL_EDIT_MODAL: {
      const { payload: well } = action;
      return {
        ...state,
        showWellEntryModal: true,
        well,
      };
    }
    case types.CLOSE_WELL_EDIT_MODAL: {
      return {
        ...state,
        showWellEntryModal: false,
        well: null,
      };
    }
    case types.OPEN_WELL_MERGE_MODAL: {
      const { payload: well } = action;
      return {
        ...state,
        showWellMergeModal: true,
        well,
      };
    }
    case types.CLOSE_WELL_MERGE_MODAL: {
      return {
        ...state,
        showWellMergeModal: false,
        well: null,
      };
    }
    default:
      return state;
  }
};

export default wellList;
